import { render, staticRenderFns } from "./InterfaceBottomText.vue?vue&type=template&id=dd4083a8&scoped=true&"
import script from "./InterfaceBottomText.vue?vue&type=script&lang=js&"
export * from "./InterfaceBottomText.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceBottomText.vue?vue&type=style&index=0&id=dd4083a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4083a8",
  null
  
)

export default component.exports